import { observer } from 'mobx-react';
import {
  ExperienceAction,
  ExperienceAvailableLanguages,
  ExperienceCompetency,
  ExperienceDescription,
  ExperienceTimeCommitment,
  ExperienceTitle,
  ExperienceUpcomingDates,
} from '../ChatbotPreview/Section/PopoverContent/Popover/Components';
import {
  ExperienceDetailResource,
  ExperienceResource,
} from '../CurrentCollectionStep/BuilderV2/Types';

interface Props {
  experienceResource: ExperienceResource;
  experienceDetailResource: ExperienceDetailResource;
  hideEnrollAction?: boolean;
}

function ExperienceVideoDetailsModalBody({
  experienceResource,
  experienceDetailResource,
  hideEnrollAction = false,
}: Props) {
  return (
    <div className="flex flex-col">
      <div className="p-2">
        <ExperienceTitle title={experienceResource.payload.title} />
      </div>
      <div className="flex h-[500px] flex-col gap-y-4 overflow-auto p-2">
        <ExperienceTimeCommitment
          experienceDetailResource={experienceDetailResource}
          experienceResource={experienceResource}
        />
        <ExperienceAvailableLanguages languages={experienceDetailResource.payload.languages} />
        <ExperienceDescription experienceDetailResource={experienceDetailResource} />
        <ExperienceCompetency experienceResource={experienceResource} />
        <ExperienceUpcomingDates experienceDetailResource={experienceDetailResource} />
      </div>
      {!hideEnrollAction && (
        <div className="p-2 pb-4">
          <ExperienceAction />
        </div>
      )}
    </div>
  );
}

export default observer(ExperienceVideoDetailsModalBody);
